"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// this function is used for analytics and should not break, so it handles an optional UserInfo even though UserInfo should always be present before analytics are sent to User Pilot
const userPilotUserContext = (userInfo) => {
    if (!userInfo) {
        return {};
    }
    const name = userInfo.firstName + ' ' + userInfo.lastName;
    return {
        name: name,
        email: userInfo.email,
        created_at: userInfo.invitationSentTimestamp,
    };
};
exports.default = userPilotUserContext;
